import { Wave } from 'common/types/common';
import { FilterOptionType, IFilterOption, IFilterOptionGroup } from 'common/types/filters';

const extractYearsFromWaves = (waves: Wave[] | undefined) => {
  const yearsList = (waves || []).map(({ date }) => new Date(date).getFullYear().toString());
  return new Set(yearsList);
};

const sortWavesByDate = (waves: Wave[] | undefined) => {
  return (waves || []).sort((waveA, waveB) => (new Date(waveA.date) > new Date(waveB.date) ? -1 : 1));
};

const createYearsMap = (years: Set<string>): Map<string, IFilterOptionGroup> => {
  return Array.from(years).reduce((acc, year) => {
    acc.set(year, {
      label: year,
      options: [],
      type: FilterOptionType.GROUP,
    });

    return acc;
  }, new Map<string, IFilterOptionGroup>());
};

const extractDateParts = (date: Date) => {
  const year = date.getFullYear().toString();
  const month = date.toLocaleDateString('en-US', { month: 'long' });
  return { year, month };
};

const mapWaveToOption = (yearsMap: Map<string, IFilterOptionGroup>, sortedWaves: Wave[]) => {
  let waveOrder = 0;

  (sortedWaves || []).forEach(({ date, id: value, name }) => {
    const { year, month } = extractDateParts(new Date(date));

    yearsMap.get(year)?.options.push({
      label: month,
      filterLabel: name,
      value,
      type: FilterOptionType.OPTION,
      optionOrder: waveOrder++,
    });
  });

  return Array.from(yearsMap.values());
};

export const groupWavesToOptions = (waves: Wave[] | undefined): (IFilterOption | IFilterOptionGroup)[] => {
  const sortedWaves = sortWavesByDate(waves);
  const years = extractYearsFromWaves(sortedWaves);
  const yearsMap = createYearsMap(years);
  return mapWaveToOption(yearsMap, sortedWaves);
};
